import {
  IconUsers,
  IconLayoutDashboard,
  IconUserPlus,
  IconCalendarCheck,
  IconId,
  IconUserStar,
  IconUser,
  IconUsersGroup,
  IconFileText,
  IconUserCheck,
  IconSettings,
  IconUserCircle,
  IconBinaryTree2,
  IconAlertHexagon,
  IconUserHexagon,
  IconStopwatch,
  IconCheckupList,
  IconReplaceUser,
  IconBuildingSkyscraper,
  IconBrandAsana,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";

export const useThemeColor = () => {
  const [themeColor, setThemeColor] = useState(
    localStorage.getItem("themeColor") || "#4e73df",
  );

  useEffect(() => {
    const rootStyles = getComputedStyle(document.documentElement);
    const newColor =
      rootStyles.getPropertyValue("--bg-base-color").trim() || "#4e73df";

    if (newColor !== themeColor) {
      localStorage.setItem("themeColor", newColor);
      setThemeColor(newColor);
    }
  }, [themeColor]);

  return themeColor;
};

export const SuperAdminSidebarApi = () => {
  // const themeColor = useThemeColor();
  return [
    {
      title: "Dashboard",
      icon: <IconLayoutDashboard size="28" color="currentColor" />,
      link: "/",
    },
    {
      title: "Admin",
      icon: <IconUserPlus size="28" color="currentColor" />,
      link: "/admin",
    },
    {
      title: "Employees",
      icon: <IconUsers size="28" color="currentColor" />,
      link: "/user",
    },
    {
      title: "Attendence",
      icon: <IconCalendarCheck size="28" color="currentColor"/>,
      link: "/attendences",
      childs: [
        {
          label: "Attendence",
          link: "/Own-Attendence",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUser size="28" color="currentColor" />,
          parent: "Attd",
        },
        {
          label: "Mispunch",
          link: "/Mispunch",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconAlertHexagon size="28" color="currentColor" />,
          parent: "Attd",
        },
      ],
    },
    {
      title: "Leads",
      icon: <IconUserHexagon size="28" color="currentColor"/>,
      link: "/leads",
      childs: [
        {
          label: "Own Leads",
          link: "/lead1",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconId size="28" color="currentColor" />,
          parent: "Leads",
        },
        {
          label: "Team's Leads",
          link: "/lead2",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserStar size="28" color="currentColor" />,
          parent: "Leads",
        },
      ],
    },
    {
      title: "Groups",
      icon: <IconUsersGroup size="28" color="currentColor" />,
      link: "/groups",
      childs: [
        {
          label: "View Groups",
          link: "/view-groups",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBrandAsana size="32" color="currentColor" />,
          parent: "Groups",
        },
        {
          label: "Leads Groups",
          link: "/leads-groups",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUsers size="28" color="currentColor" />,
          parent: "Groups",
        },
      ],
    },
    {
      title: "Report",
      icon: <IconCheckupList size="32" color="currentColor" />,
      link: "/reports",
      childs: [
        {
          label: "Emp Report",
          link: "/empreport",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconFileText size="32" color="currentColor"/>,
          parent: "Report",
        },
        {
          label: "Talk Time",
          link: "/talk-time",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconStopwatch size="32" color="currentColor" />,
          parent: "Report",
        },
        {
          label: "Employee Status",
          link: "/emp-status",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserCheck size="32" color="currentColor" />,
          parent: "Report",
        },
      ],
    },
    {
      title: "Settings",
      icon: <IconSettings size="32" color="currentColor" />,
      link: "/settings",
      childs: [
        {
          label: "Role",
          link: "/role",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserCircle size="32" color="currentColor" />,
          parent: "Settings",
        },
        {
          label: "Company",
          link: "/company",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBuildingSkyscraper size="28" color="currentColor" />,
          parent: "Settings",
        },
        {
          label: "TeamChanges",
          link: "/team-changes",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconReplaceUser size="28" color="currentColor"/>,
          parent: "Settings",
        },
        {
          label: "Emp Structure",
          link: "/employee-tree",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBinaryTree2 size="28" color="currentColor" />,
          parent: "Settings",
        },
      ],
    },
  ];
};

export const AdminSidebarApi = () => {
  // const themeColor = useThemeColor();

  return [
    {
      title: "Dashboard",
      icon: <IconLayoutDashboard size="28" color="currentColor" />,
      link: "/",
    },
    {
      title: "Employees",
      icon: <IconUsers size="28" color="currentColor" />,
      link: "/user",
    },
    {
      title: "Attendence",
      icon: <IconCalendarCheck size="28" color="currentColor" />,
      link: "/attendences",
      childs: [
        {
          label: " Attendence",
          link: "/Own-Attendence",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUser size="28" color="currentColor" />,
          parent: "Attd",
        },
        {
          label: "Mispunch",
          link: "/Mispunch",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconAlertHexagon size="28" color="currentColor" />,
          parent: "Attd",
        },
      ],
    },
    {
      title: "Leads",
      icon: <IconUserHexagon size="28" color="currentColor" />,
      link: "/leads",
      childs: [
        {
          label: "Own Leads",
          link: "/lead1",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconId size="28" color="currentColor" />,
          parent: "Leads",
        },
        {
          label: "Team's Leads",
          link: "/lead2",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserStar size="28" color="currentColor" />,
          parent: "Leads",
        },
      ],
    },
    {
      title: "Groups",
      icon: <IconUsersGroup size="28" color="currentColor" />,
      link: "/groups",
      childs: [
        {
          label: "View Groups",
          link: "/view-groups",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBrandAsana size="32" color="currentColor" />,
          parent: "Groups",
        },
        {
          label: "Leads Groups",
          link: "/leads-groups",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUsers size="28" color="currentColor" />,
          parent: "Groups",
        },
      ],
    },
    {
      title: "Report",
      icon: <IconCheckupList size="32" color="currentColor" />,
      link: "/reports",
      childs: [
        {
          label: "Emp Report",
          link: "/empreport",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconFileText size="32" color="currentColor" />,
          parent: "Report",
        },
        {
          label: "Talk Time",
          link: "/talk-time",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconStopwatch size="32" color="currentColor" />,
          parent: "Report",
        },
        {
          label: "Employee Status",
          link: "/emp-status",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserCheck size="32" color="currentColor" />,
          parent: "Report",
        },
      ],
    },
    {
      title: "Settings",
      icon: <IconSettings size="32" color="currentColor" />,
      link: "/settings",
      childs: [
        {
          label: "Role",
          link: "/role",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserCircle size="32" color="currentColor" />,
          parent: "Settings",
        },
        {
          label: "TeamChanges",
          link: "/team-changes",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconReplaceUser size="28" color="currentColor" />,
          parent: "Settings",
        },
        {
          label: "Emp Structure",
          link: "/employee-tree",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBinaryTree2 size="28" color="currentColor" />,
          parent: "Settings",
        },
      ],
    },
  ];
};

export const OtherRoleSidebarApi = () => {
  // const themeColor = useThemeColor();

  return [
    {
      title: "Dashboard",
      icon: <IconLayoutDashboard size="28" color="currentColor" />,
      link: "/",
    },
    {
      title: "Employees",
      icon: <IconUsers size="28" color="currentColor" />,
      link: "/user",
    },
    {
      title: "Attendence",
      icon: <IconCalendarCheck size="28" color="currentColor" />,
      link: "/attendences",
      childs: [
        {
          label: "Own",
          link: "/Own-Attendence",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconId size="28" color="currentColor" />,
          parent: "Attd",
        },
        {
          label: "Team",
          link: "/Team-Attendence",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUsersGroup size="32" color="currentColor" />,
          parent: "Attd",
        },
        {
          label: "Mispunch",
          link: "/Mispunch",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconAlertHexagon size="28" color="currentColor" />,
          parent: "Attd",
        },
      ],
    },
    {
      title: "Leads",
      icon: <IconUserHexagon size="28" color="currentColor" />,
      link: "/leads",
      childs: [
        {
          label: "Own Leads",
          link: "/lead1",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconId size="28" color="currentColor"/>,
          parent: "Leads",
        },
        {
          label: "Team's Leads",
          link: "/lead2",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserStar size="28" color="currentColor" />,
          parent: "Leads",
        },
      ],
    },
    {
      title: "Report",
      icon: <IconCheckupList size="32" color="currentColor" />,
      link: "/reports",
      childs: [
        {
          label: "Emp Report",
          link: "/empreport",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconFileText size="32" color="currentColor" />,
          parent: "Report",
        },
        {
          label: "Talk Time",
          link: "/talk-time",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconStopwatch size="32" color="currentColor" />,
          parent: "Report",
        },
        {
          label: "Employee Status",
          link: "/emp-status",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconUserCheck size="32" color="currentColor" />,
          parent: "Report",
        },
      ],
    },
    {
      title: "Heirachy",
      icon: <IconBinaryTree2 size="32" color="currentColor" />,
      link: "/employeetree",
      childs: [
        {
          label: "Emp Structure",
          link: "/employee-tree",
          view: true,
          add: true,
          edit: false,
          delete: false,
          export: false,
          icon: <IconBinaryTree2 size="28" color="currentColor" />,
          parent: "Settings",
        },
      ],
    },
  ];
};
